import React, { useState } from 'react';
import Dropdown, { DropdownTheme } from 'Douleutaras/components/Dropdown/Dropdown';
import { CategoryMenu } from 'Douleutaras/types';
import { CategoriesMenuItem } from 'Douleutaras/types/categoriesMenu';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import './AllCategoriesDropdown.scss';

const AllCategoriesDropdown: React.FC<{ categoriesMenu: Array<CategoryMenu> }> = ({ categoriesMenu }) => {
  const { t } = useTranslation();
  const [listsDropdown, setListsDropdown] = useState(false);

  return (
    <Dropdown
      title={t('All categories')}
      callback={setListsDropdown}
      isOpen={listsDropdown}
      theme={DropdownTheme.FULL}
      header={
        <div styleName={classNames({
          'header-categories': true,
          'header-categories--active': listsDropdown
        })}>
          <button styleName="header-categories__link" onClick={() => setListsDropdown(true)}>
            <span styleName="header-categories__icon" className="dashicon dashicon-briefcase" />
            <span styleName="header-categories__title">{t('All categories')}</span>
          </button>
        </div>
      }
    >
      <div className="list-dropdown__content">
        {categoriesMenu?.map((item: CategoriesMenuItem, index: number) => (
          <div className="list-dropdown__item" key={`${item.title}-${index}`}>
            <div className="list-dropdown__category">
              <span className="list-dropdown__icon">
                {item.icon && <img src={item.icon} alt="" />}
              </span>
              <span className="list-dropdown__title">{item.title}</span>
            </div>
            {item.children?.length > 0 && (
              <div className="list-dropdown__list">
                {item.children.map((child: CategoriesMenuItem, childIndex: number) => (
                  <a
                    className="list-dropdown__link"
                    key={`${child.title}-child-${childIndex}`}
                    href={child.url}
                  >
                    {child.title}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </Dropdown>
  );
};

export default AllCategoriesDropdown;
